'use strict';

const GPIO_IN_MODE = {
    0x00: 'IO_RISING',
    0x01: 'IO_FALLING',
    0x02: 'IO_RISING_FALLING',
    0x03: 'IO_TRIGGER_HIGH',
    0x04: 'IO_TRIGGER_LOW'
};

function parse(reader) {
    reader.readUInt8('data.params.rule_index');
    reader.readUInt8('data.params.digit_index');
    reader.readUInt8('data.params.mode', value => GPIO_IN_MODE[value]);
    reader.readUInt32LE('data.params.jitter_time');
    reader.readUInt32LE('data.params.lockout_time');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/common/rule/digit-condition-parser.js